/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import PositionFrame from './position-frame';

/**
 * @import { ViewerFrameFactory } from '../viewer/frame'
 */

/**
 * Továrna na rámy pro zobrazování médií,
 * které provádí skrývání pomocí pozicování rámů mimo obrazovku.
 * @implements {ViewerFrameFactory}
 */
export default class PositionFrameFactory {
  /** @type {ViewerFrameFactory['create']} */
  create() {
    return new PositionFrame();
  }
}
